const inputs = document.querySelectorAll('.search-bar__input');

inputs.forEach((element, key)=>{
    element.addEventListener('focusin', ( event )=>{
        if (event.target.matches(':focus-visible') && event.relatedTarget !== null) {
            // Encontra o elemento pai usando a propriedade parentNode
            const parentElement = event.target.parentNode;
            parentElement.classList.add('focus-visible');
        }
    });
    element.addEventListener('focusout', ( event ) => {
        // Encontra o elemento pai usando a propriedade parentNode
        const parentElement = event.target.parentNode;
        parentElement.classList.remove('focus-visible');
    });
});